import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { HttpService } from '../http.service';

/**
 * @title Table retrieving data through HTTP
 */
@Component({
  selector: 'app-status-ff',
  templateUrl: './status-ff.component.html',
  styleUrls: ['./status-ff.component.scss']
})



export class StatusFfComponent implements AfterViewInit {
  displayedColumns: string[] = ['number', 'state', 'created'];
  exampleDatabase: ExampleHttpDatabase | null;
  data: GithubIssue[] = [];
  coins;
  la_fecha_corte;


  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  constructor(private _httpClient: HttpClient, private _hs: HttpService) { }





  ngAfterViewInit() {

    this._hs.ffs_pendientes().subscribe(res => {
      this.coins = <any>res;
      this.la_fecha_corte = "el primer cambio";
      console.log("vamos con el resultado en ngAfterViewInit")
      console.log(this.coins);
    } );

    

    this.exampleDatabase = new ExampleHttpDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);


    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.exampleDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          console.log("vamos en la 72")
    console.log(data)

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  


  }

  setClasses(fecha_creado) {
    let hoy = new Date();
    let fecha_pago = new Date(fecha_creado);

    let fecha_corte = new Date(this.coins);


   
    let myClasses = {
     // retrasado: Date.parse(fecha_corte.toISOString()) > Date.parse(fecha_creado),
     // a_tiempo: Date.parse(fecha_corte.toISOString()) < Date.parse(fecha_creado),
    }

    return  myClasses
  }




}



export interface GithubApi {
  items: GithubIssue[];
  total_count: number;
}

export interface GithubIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class ExampleHttpDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number): Observable<GithubApi> {
    console.log(sort)
    console.log(order)
    console.log(page)
    const href = 'https://vertigofin.herokuapp.com/query_consignors.json';
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}`;

    return this._httpClient.get<GithubApi>(requestUrl);
  }
}
